'use client';

import { GirlDesktopMobile } from '@/components/girl/girl-desktop-mobile';
import { GirlPrices } from '@/components/girl/girl-prices';
import { GirlSedcard } from '@/components/girl/girl-sedcard';
import dynamic from 'next/dynamic';
const RequestModal = dynamic(() => import('./request-modal'));

import { attendantAboutTitle, attendantFeeTitle } from '@bells/i18n';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@bells/ui/components/tabs';
import { GirlDesktopHeader } from './girl-desktop-header';
import { useState } from 'react';
import LikeProvider from '@/components/likes/like.provider';
export const GirlLayout = ({
  data,
}: {
  data: AttendantSearchSingleResponse;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <LikeProvider
      likes={data.totalLikes}
      entity={'AttendantEntity'}
      entityId={data.id}
    >
      <div className='mx-auto flex w-full max-w-screen-xl flex-col gap-4 px-4 py-3 pb-8 md:my-16 lg:px-8'>
        <RequestModal data={data} open={open} setOpen={setOpen}></RequestModal>

        <div className='grid grid-cols-12 gap-8'>
          <div className='col-span-12 hidden lg:col-span-4 lg:block'>
            <GirlDesktopHeader
              setOpen={setOpen}
              data={data}
            ></GirlDesktopHeader>
          </div>
          <div className='col-span-12 block lg:col-span-4 lg:hidden'>
            <GirlDesktopMobile
              setOpen={setOpen}
              data={data}
            ></GirlDesktopMobile>
          </div>
          <div className='col-span-12 lg:col-span-8'>
            <Tabs defaultValue='home' className='mb-4 w-full'>
              <TabsList className='mb-4 w-full justify-start rounded-none border-b border-foreground/15 bg-transparent pb-1'>
                <TabsTrigger
                  value={'home'}
                  className='-mb-1 rounded-none border-b-2 border-transparent text-base font-medium data-[state=active]:border-foreground data-[state=active]:shadow-none'
                >
                  {attendantAboutTitle()}
                </TabsTrigger>
                <TabsTrigger
                  value={`prices`}
                  className='-mb-1 rounded-none border-b-2 border-transparent text-base font-medium data-[state=active]:border-foreground data-[state=active]:shadow-none'
                >
                  {attendantFeeTitle()}
                </TabsTrigger>
              </TabsList>

              <TabsContent value='home'>
                <GirlSedcard data={data}></GirlSedcard>
              </TabsContent>
              <TabsContent value='prices'>
                <GirlPrices data={data}></GirlPrices>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </LikeProvider>
  );
};
